module.exports = __webpack_public_path__ + "img/addVideoWhite.c85346f1.svg";